import { useState, useEffect } from "react";
import { highlighWithShiki } from "../utils/common";
import clsx from "clsx";

export default function CodeShiki({ code, cx }: { code: string; cx: string }) {
  const [highlighted, setHighlighted] = useState<string>("");

  useEffect(() => {
    highlighWithShiki(code).then(setHighlighted);
  }, [code]);

  return (
    <div
      className={clsx("whitespace-pre-line", cx)}
      dangerouslySetInnerHTML={{
        __html: highlighted,
      }}
    />
  );
}
